<template>
  <div id="page-user-list">
    <vs-card>
      <!-- {{ criterias }} -->
      <vs-table search stripe :data="criterias">
        <template slot="header">
          <vs-button
            v-if="canAddPayroll"
            @click="popupAdd = true"
            icon-pack="feather"
            icon="icon-plus"
            color="primary"
            type="border"
            class="mb-2"
            >Adicionar critério</vs-button
          >
        </template>

        <template slot="thead">
          <vs-th sort-key="name">Nome</vs-th>
          <vs-th sort-key="surname">Descrição</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>

            <vs-td :data="data[indextr].description">
              {{ data[indextr].description }}
            </vs-td>

            <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
              <vs-row>
                <vs-button
                  :disabled="data[indextr].company_id == null"
                  color="success"
                  size="small"
                  hover:text-danger
                  type="border"
                  icon-pack="feather"
                  icon="icon-edit"
                  @click="popupOpenEdit(tr)"
                ></vs-button>
                <!-- <vs-button :disabled="data[indextr].company_id==null" class="ml-2" color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" @click="openConfirm(tr)"></vs-button> -->
              </vs-row>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div
        style="height: 50px"
        id="div-with-loading"
        class="vs-con-loading__container"
      ></div>
    </vs-card>

    <vs-popup
      class="holamundo"
      title="Actualizar Critério"
      :active.sync="popupEdit"
    >
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Nome</label>
          <vs-input
            class="w-full mt-2 mb-5"
            type="text"
            v-model="criteria.name"
            v-validate="'required|alpha_spaces'"
            name="Nome do componente"
          />
          <span class="text-danger text-sm" v-show="errors.has('Nome')">{{
            errors.first("Nome")
          }}</span>

          <label class="mt-8" for="">Descrição</label>
          <vs-input
            class="w-full mt-2 mb-5"
            type="text"
            v-model="criteria.description"
            v-validate="'required|alpha_spaces'"
            name="Nome do componente"
          />
          <span class="text-danger text-sm" v-show="errors.has('Descricao')">{{
            errors.first("Descricao")
          }}</span>
        </div>

        <div class="vx-col w-full mb-2">
          <div class="flex flex-wrap items-center flex-start">
            <vs-button class="ml-auto mt-2" @click="editData"
              >Actualizar</vs-button
            >
            <vs-button
              class="ml-4 mt-2"
              type="border"
              color="warning"
              @click="cancelarPopEdit"
              >Cancelar</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo"
      title="Adicionar Critério"
      :active.sync="popupAdd"
    >
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Nome</label>
          <vs-input
            class="w-full mt-2 mb-5"
            type="text"
            v-model="name"
            v-validate="'required|alpha_spaces'"
            name="nome"
          />
          <span class="text-danger text-sm" v-show="errors.has('nome')">{{
            errors.first("nome")
          }}</span>
        </div>

        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Descrição</label>
          <vs-input
            class="w-full mt-2 mb-5"
            type="text"
            v-model="description"
            name="descricao"
          />
        </div>

        <div class="vx-col w-full mb-2">
          <div class="flex flex-wrap items-center flex-start">
            <vs-button class="ml-auto mt-2" @click="saveData">Salvar</vs-button>
            <vs-button
              class="ml-4 mt-2"
              type="border"
              color="warning"
              @click="cancelarPopAdd"
              >Cancelar</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import http from "../../../../http-common";
import { PermissionsMixin } from "../../../mixins/permissions";
// Store Module

// Cell Renderer

export default {
  mixins: [PermissionsMixin],
  components: {
    vSelect,
  },
  data() {
    return {
      criterias: [],
      criteria: [],
      name: "",
      // percent:"",
      description: "",
      popupAdd: false,
      popupEdit: false,

      // dados:[],

      employees: [],
      currentUser: [],
    };
  },

  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.getData();

      // this.getCurrentUser();
    },
    cancelarPopAdd() {
      // Lógica para cancelar (por exemplo, voltar à página anterior)

      this.popupAdd = false;
    },
    cancelarPopEdit() {
      this.popupEdit = false;
    },
    // openConfirm(criteria) {

    //   this.criteria=criteria
    //             this.$vs.dialog({
    //                 type: 'confirm',
    //                 color: 'danger',
    //                 title: `Confirmação`,
    //                 text: 'Tem certeza que deseja eliminar?' ,
    //                 accept: this.remove
    //             })
    //         },

    //     async remove(criteria) {

    //          this.criteria=criteria
    //       //  this.$vs.loading()

    //   let token = localStorage.getItem("token");
    //   let config = {
    //     headers: {
    //       authorization: "Bearer " + token,
    //     },
    //   };

    //  http
    //     .delete(`/performances/delete_criteria/${this.criteria.id}`, config)
    //     .then((success) => {
    //       success;

    //     this.getData(),
    //       this.$vs.loading.close();
    //       this.$vs.notify({
    //         title: "Sucesso",
    //         text: "Removido com sucesso!",
    //         color: "success",
    //         position: "top-right",
    //       })
    //     })
    //     .catch((error) => {
    //       error;
    //       this.err= error.response.data
    //       this.$vs.loading.close();
    //       this.$vs.notify({
    //         title: "Erro",
    //         text: this.err,
    //         iconPack: "feather",
    //         icon: "icon-alert-circle",
    //         color: "danger",
    //         position: "top-right",
    //       })
    //     });

    // },

    getCurrentUser() {
      this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      http
        .get("/auth/me", config)
        .then((success) => {
          this.$vs.loading.close();
          this.currentUser = success.data.User;

          this.newArray = this.currentUser.permissions.filter(function (el) {
            return el.name == "create Employee";
          });
        })
        .catch((error) => {
          error;
        });
    },

    getData() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 1.0,
        type: "sound",
      });

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/performances/criterias", config)
        .then((result) => {
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          this.criterias = result.data.data;
          // alert("2")
        })
        .catch((error) => {
          error;
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },

    async saveData() {
      this.$validator.validate("nome").then((result) => {
        if (result) {
          this.$vs.loading();

          let token = localStorage.getItem("token");
          let config = {
            headers: {
              authorization: "Bearer " + token,
            },
          };

          const data = {
            name: this.name,
            // percent:this.percent,
            description: this.description,
          };

          http
            .post("/performances/criterias", data, config)
            .then((success) => {
              success;
              (this.popupAdd = false),
                (this.name = ""),
                (this.abbreviation = ""),
                (this.type = ""),
                this.getData(),
                this.$vs.loading.close();
              this.$vs.notify({
                title: "Sucesso",
                text: "Critério adicionado com sucesso!",
                color: "success",
                position: "top-right",
              });
            })
            .catch((error) => {
              error;
              this.err = error.response.data;
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Erro",
                text: this.err,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-right",
              });
            });
        }
      });
    },

    popupOpenEdit(criteria) {
      (this.criteria = criteria), (this.popupEdit = true);
    },

    async editData() {
      this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      const data = {
        name: this.criteria.name,
        description: this.criteria.description,
      };

      this.$validator.validateAll();
      http
        .put(`/performances/criterias/${this.criteria.id}`, data, config)
        .then((success) => {
          success;
          (this.popupEdit = false), this.getData(), this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Critério actualizado com sucesso!",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.err = error.response.data;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
    },
  },
};
</script>
